module.exports = __webpack_public_path__ + "static/img/chuanganbianjie.dabc206.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/font/chuanganbianjie.png
// module id = 7b82
// module chunks = 1